module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form",
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('wi-save', {
    attrs: {
      "slot": "header",
      "form": ['mainForm', 'contactForm'],
      "title": _vm.$t('SCHOOLCONFIGURATION'),
      "data": {
        school: this.school,
        address: this.address,
        grades: this.grades,
        timing: this.timing,
        terms: this.academicTerms
      },
      "redirect": false,
      "auth": true
    },
    slot: "header"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-tabs', {
    staticClass: "tabs",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.school,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('wi-upload', {
    attrs: {
      "person": _vm.school,
      "logo": true
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('TYPESOFSCHOOL'),
      "prop": "Type",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.school.Type),
      callback: function($$v) {
        _vm.$set(_vm.school, "Type", $$v)
      },
      expression: "school.Type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('PUBLIC')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('PRIVATE')))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GENDERDIVERSITY'),
      "prop": "Gender",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.school.Gender),
      callback: function($$v) {
        _vm.$set(_vm.school, "Gender", $$v)
      },
      expression: "school.Gender"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Male"
    }
  }, [_vm._v(_vm._s(_vm.$t('MALE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Female"
    }
  }, [_vm._v(_vm._s(_vm.$t('FEMALE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Mixed"
    }
  }, [_vm._v(_vm._s(_vm.$t('MIXED')))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NAME'),
      "prop": "Name_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.Name_EN),
      callback: function($$v) {
        _vm.$set(_vm.school, "Name_EN", $$v)
      },
      expression: "school.Name_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NAME(ARABIC)'),
      "prop": "Name_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.Name_AR),
      callback: function($$v) {
        _vm.$set(_vm.school, "Name_AR", $$v)
      },
      expression: "school.Name_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('COUNTRY'),
      "prop": "Country",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('PLEASESELECTYOURZONE'),
      "filterable": ""
    },
    on: {
      "change": function($event) {
        _vm.changeAutoComplete()
      }
    },
    model: {
      value: (_vm.school.Country),
      callback: function($$v) {
        _vm.$set(_vm.school, "Country", $$v)
      },
      expression: "school.Country"
    }
  }, _vm._l((_vm.$countries), function(stop, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": stop,
        "value": key
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DATEFORMAT')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTDATEFORMAT')
    },
    model: {
      value: (_vm.school.DateFormat),
      callback: function($$v) {
        _vm.$set(_vm.school, "DateFormat", $$v)
      },
      expression: "school.DateFormat"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('DAYMONTHYEAR'),
      "value": "dd/MM/yyyy"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('MONTHDAYYEAR'),
      "value": "MM/dd/yyyy"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ADDRESS')
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "addressBar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.cardHeight - 42 + 'px'
    })
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.address,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticClass: "googleMap"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "200px"
    },
    attrs: {
      "id": "school-gmap"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school.Address),
      expression: "school.Address"
    }],
    staticClass: "el-input__inner",
    staticStyle: {
      "padding": "25px 10px"
    },
    attrs: {
      "disabled": !_vm.school.Country,
      "type": "text",
      "placeholder": _vm.$t('SEARCHADDRESS'),
      "id": "location",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.school.Address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.school, "Address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('COORDINATES')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    on: {
      "change": function($event) {
        _vm.enableConfirm = true
      }
    },
    model: {
      value: (_vm.school.Lat),
      callback: function($$v) {
        _vm.$set(_vm.school, "Lat", $$v)
      },
      expression: "school.Lat"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$t('LATITUDE')))])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    on: {
      "change": function($event) {
        _vm.enableConfirm = true
      }
    },
    model: {
      value: (_vm.school.Lng),
      callback: function($$v) {
        _vm.$set(_vm.school, "Lng", $$v)
      },
      expression: "school.Lng"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$t('LONGITUDE')))])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.enableConfirm
    },
    on: {
      "click": function($event) {
        _vm.changeMarkerPosition(_vm.school.Lat, _vm.school.Lng)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('BUILDINGNUMBER')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.HouseNumber),
      callback: function($$v) {
        _vm.$set(_vm.address, "HouseNumber", $$v)
      },
      expression: "address.HouseNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STREETADDRESS')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.Address),
      callback: function($$v) {
        _vm.$set(_vm.address, "Address", $$v)
      },
      expression: "address.Address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('AREA')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.Area),
      callback: function($$v) {
        _vm.$set(_vm.address, "Area", $$v)
      },
      expression: "address.Area"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('ZONE')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.Zone),
      callback: function($$v) {
        _vm.$set(_vm.address, "Zone", $$v)
      },
      expression: "address.Zone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SECTOR')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.Sector),
      callback: function($$v) {
        _vm.$set(_vm.address, "Sector", $$v)
      },
      expression: "address.Sector"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('CITY')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.City),
      callback: function($$v) {
        _vm.$set(_vm.address, "City", $$v)
      },
      expression: "address.City"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STATE')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.State),
      callback: function($$v) {
        _vm.$set(_vm.address, "State", $$v)
      },
      expression: "address.State"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('ZIPCODE')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.school.Country
    },
    model: {
      value: (_vm.address.ZipCode),
      callback: function($$v) {
        _vm.$set(_vm.address, "ZipCode", $$v)
      },
      expression: "address.ZipCode"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('CONTACTS')
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('img', {
    staticClass: "media-object img-circle",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.adminImage, 'user')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.$t('SEARCHUSERSNAME'),
      "icon": "search"
    },
    on: {
      "select": _vm.changeUser
    },
    model: {
      value: (_vm.admin),
      callback: function($$v) {
        _vm.admin = $$v
      },
      expression: "admin"
    }
  })], 1)])]), _vm._v(" "), _c('el-form', {
    ref: "contactForm",
    staticStyle: {
      "margin-top": "15px",
      "padding": "15px"
    },
    attrs: {
      "model": _vm.school,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SCHOOLEMAIL'),
      "prop": "AdminEmail",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 6,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 6
        }),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur'
      }, {
        max: 50,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 50
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.AdminEmail),
      callback: function($$v) {
        _vm.$set(_vm.school, "AdminEmail", $$v)
      },
      expression: "school.AdminEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SCHOOLPHONENUMBER'),
      "prop": "AdminPhone",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.AdminPhone),
      callback: function($$v) {
        _vm.$set(_vm.school, "AdminPhone", $$v)
      },
      expression: "school.AdminPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('BUSCOMPANYEMAIL'),
      "prop": "BusCompanyEmail",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 6,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 6
        }),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur'
      }, {
        max: 50,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 50
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.BusCompanyEmail),
      callback: function($$v) {
        _vm.$set(_vm.school, "BusCompanyEmail", $$v)
      },
      expression: "school.BusCompanyEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('BUSCOMPANYPHONENUMBER'),
      "prop": "BusCompanyContact",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.BusCompanyContact),
      callback: function($$v) {
        _vm.$set(_vm.school, "BusCompanyContact", $$v)
      },
      expression: "school.BusCompanyContact"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LOCALPOLICEEMAIL'),
      "prop": "PoliceEmail",
      "rules": [{
        min: 6,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 6
        }),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur'
      }, {
        max: 50,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 50
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.PoliceEmail),
      callback: function($$v) {
        _vm.$set(_vm.school, "PoliceEmail", $$v)
      },
      expression: "school.PoliceEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LOCALPOLICEPHONENUMBER'),
      "prop": "PoliceContact",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validator: _vm.phoneValidation,
        message: _vm.$t('INVALIDPHONENO'),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.school.PoliceContact),
      callback: function($$v) {
        _vm.$set(_vm.school, "PoliceContact", $$v)
      },
      expression: "school.PoliceContact"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('GRADES')
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-form', {
    ref: "gradeForm",
    attrs: {
      "model": _vm.grade,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "prop": "Grade",
      "rules": [{
        min: 1,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 1
        }),
        trigger: 'blur'
      }, {
        max: 10,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 8
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('GRADE')
    },
    model: {
      value: (_vm.grade.Grade),
      callback: function($$v) {
        _vm.$set(_vm.grade, "Grade", $$v)
      },
      expression: "grade.Grade"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('AGE')
    },
    model: {
      value: (_vm.grade.Age),
      callback: function($$v) {
        _vm.$set(_vm.grade, "Age", $$v)
      },
      expression: "grade.Age"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.gradeValidation()
    },
    on: {
      "click": _vm.newGrade
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.gradeIndex == null ? _vm.$t('ADDGRADE') : _vm.$t('SAVE')) + "\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.grades,
      "height": _vm.cardHeight - 118
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-row', {
          attrs: {
            "gutter": 20
          }
        }, [_vm._l((props.row.Classes), function(value, index) {
          return _c('el-col', {
            key: index,
            staticStyle: {
              "margin-bottom": "10px"
            },
            attrs: {
              "span": 6
            }
          }, [_c('el-input', {
            model: {
              value: (props.row.Classes[index]),
              callback: function($$v) {
                _vm.$set(props.row.Classes, index, $$v)
              },
              expression: "props.row.Classes[index]"
            }
          }, [_c('el-button', {
            attrs: {
              "slot": "prepend",
              "icon": "close"
            },
            on: {
              "click": function($event) {
                props.row.Classes.splice(index, 1)
              }
            },
            slot: "prepend"
          })], 1)], 1)
        }), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 4
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "disabled": props.row.Classes[props.row.Classes.length - 1] == ''
          },
          on: {
            "click": function($event) {
              props.row.Classes.push('')
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" " + _vm._s(_vm.$t('ADDNEWCLASS')))])], 1)], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('GRADE'),
      "prop": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('AVERAGEAGE'),
      "prop": "Age",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITGRADE'),
            "placement": "top"
          }
        }, [(props.$index != _vm.gradeIndex) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editGrade(props.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('DELETEGRADE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteGrade(props.$index, props.row.GradeID, props.row.Name)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('TIMINGS')
    }
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "model": _vm.timing,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GATEOPENTIME')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('GATEOPENTIME'),
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.timing.GateOpen),
      callback: function($$v) {
        _vm.$set(_vm.timing, "GateOpen", $$v)
      },
      expression: "timing.GateOpen"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('CLASSSTARTTIME')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('CLASSSTARTTIME'),
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '24:00',
        minTime: _vm.timing.OpenTime
      }
    },
    model: {
      value: (_vm.timing.ClassStart),
      callback: function($$v) {
        _vm.$set(_vm.timing, "ClassStart", $$v)
      },
      expression: "timing.ClassStart"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LATEARRIVALTIME')
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": _vm.$t('SELECTMINUTES')
    },
    model: {
      value: (_vm.timing.LateArrival),
      callback: function($$v) {
        _vm.$set(_vm.timing, "LateArrival", $$v)
      },
      expression: "timing.LateArrival"
    }
  }, _vm._l((_vm.minutes), function(num, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": num + ' ' + _vm.$t('MIN'),
        "value": num
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('EARLYDEPARTURETIME')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('EARLYDEPARTURETIME'),
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '24:00',
        minTime: _vm.timing.ArrivalTime
      }
    },
    model: {
      value: (_vm.timing.EarlyDeparture),
      callback: function($$v) {
        _vm.$set(_vm.timing, "EarlyDeparture", $$v)
      },
      expression: "timing.EarlyDeparture"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('CLASSENDTIME')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('CLASSENDTIME'),
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '24:00',
        minTime: _vm.timing.DepartureTime
      }
    },
    model: {
      value: (_vm.timing.ClassEnd),
      callback: function($$v) {
        _vm.$set(_vm.timing, "ClassEnd", $$v)
      },
      expression: "timing.ClassEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GATECLOSETIME')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('GATECLOSETIME'),
      "picker-options": {
        start: '00:15',
        step: '00:15',
        end: '24:00',
        minTime: _vm.timing.EndTime
      }
    },
    model: {
      value: (_vm.timing.GateClose),
      callback: function($$v) {
        _vm.$set(_vm.timing, "GateClose", $$v)
      },
      expression: "timing.GateClose"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ACADEMICTERMS')
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.newTerm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('ADDNEXTACADEMICYEAR')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.academicTerms,
      "height": _vm.cardHeight - 118
    },
    on: {
      "expand": _vm.expandRow
    }
  }, [_c('el-table-column', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.terms.length != 0) ? _c('el-row', {
          staticStyle: {
            "font-weight": "bold"
          },
          attrs: {
            "gutter": 20
          }
        }, [_c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('TERMNAME')) + "\n            ")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('STARTDATE')) + "\n            ")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('ENDDATE')) + "\n            ")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 2
          }
        })], 1) : _vm._e(), _vm._v(" "), _vm._l((props.row.terms), function(term, key) {
          return _c('el-row', {
            key: key,
            staticStyle: {
              "padding": "15px 0"
            },
            attrs: {
              "gutter": 20
            }
          }, [_c('el-col', {
            attrs: {
              "span": 6
            }
          }, [_c('el-input', {
            attrs: {
              "disabled": term.IsDeleted == 1
            },
            model: {
              value: (term.Name),
              callback: function($$v) {
                _vm.$set(term, "Name", $$v)
              },
              expression: "term.Name"
            }
          })], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('el-date-picker', {
            attrs: {
              "disabled": term.IsDeleted == 1,
              "format": _vm.date_format,
              "type": "date",
              "picker-options": {
                disabledDate: _vm.activeDates
              },
              "placeholder": _vm.$t('STARTDATE'),
              "default-value": new Date(props.row.year.split('/')[0] + '-01-01')
            },
            on: {
              "change": function($event) {
                _vm.restricNextDate(term.StartDate, key)
              }
            },
            model: {
              value: (term.StartDate),
              callback: function($$v) {
                _vm.$set(term, "StartDate", $$v)
              },
              expression: "term.StartDate"
            }
          })], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('el-date-picker', {
            attrs: {
              "disabled": term.IsDeleted == 1,
              "format": _vm.date_format,
              "type": "date",
              "placeholder": _vm.$t('ENDDATE'),
              "default-value": new Date(props.row.year.split('/')[0] + '-01-01')
            },
            model: {
              value: (term.EndDate),
              callback: function($$v) {
                _vm.$set(term, "EndDate", $$v)
              },
              expression: "term.EndDate"
            }
          })], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 2
            }
          }, [_c('i', {
            staticClass: "fa",
            class: [term.IsDeleted == 0 ? 'fa-times' : ' fa-undo'],
            staticStyle: {
              "font-size": "25px",
              "margin-top": "5px"
            },
            on: {
              "click": function($event) {
                term.IsDeleted = (term.IsDeleted == 0 ? 1 : 0)
              }
            }
          })])], 1)
        }), _vm._v(" "), _c('el-row', [_c('el-button', {
          on: {
            "click": function($event) {
              props.row.terms.push({
                Name: '',
                YearID: props.row.YearID,
                StartDate: '',
                EndDate: '',
                IsDeleted: 0
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" " + _vm._s(_vm.$t('ADDNEWTERM')))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('YEAR'),
      "prop": "year"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STARTINGDATE')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n              " + _vm._s(props.row.terms.length == 0 ? '-' : _vm.dateFormat(props.row.terms[0].StartDate)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('ENDINGDATE')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n              " + _vm._s(props.row.terms.length == 0 ? '-' : _vm.dateFormat(props.row.terms[props.row.terms.length - 1].EndDate)) + "\n            ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ACTIVITIES')
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('ACTIVITYNAME')
    },
    model: {
      value: (_vm.Activity.Name),
      callback: function($$v) {
        _vm.$set(_vm.Activity, "Name", $$v)
      },
      expression: "Activity.Name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('STARTTIME'),
      "picker-options": {
        start: '06:00',
        step: '00:15',
        end: '16:00'
      }
    },
    model: {
      value: (_vm.Activity.StartTime),
      callback: function($$v) {
        _vm.$set(_vm.Activity, "StartTime", $$v)
      },
      expression: "Activity.StartTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('ENDTIME'),
      "disabled": _vm.Activity.StartTime == null,
      "picker-options": {
        start: _vm.Activity.StartTime,
        step: '00:15',
        end: '16:00',
        minTime: _vm.Activity.StartTime
      }
    },
    model: {
      value: (_vm.Activity.EndTime),
      callback: function($$v) {
        _vm.$set(_vm.Activity, "EndTime", $$v)
      },
      expression: "Activity.EndTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": _vm.$t('PICKADATE')
    },
    model: {
      value: (_vm.Activity.Date),
      callback: function($$v) {
        _vm.$set(_vm.Activity, "Date", $$v)
      },
      expression: "Activity.Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": _vm.$t('SELECTDAYS')
    },
    model: {
      value: (_vm.Activity.Days),
      callback: function($$v) {
        _vm.$set(_vm.Activity, "Days", $$v)
      },
      expression: "Activity.Days"
    }
  }, _vm._l((_vm.daysC), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.Activity.Name == null
    },
    on: {
      "click": _vm.saveActivity
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.Activity.ID == null ? _vm.$t('ADDACTIVITY') : _vm.$t('SAVE')) + "\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.activities,
      "height": _vm.cardHeight - 118
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('ACTIVITYNAME'),
      "prop": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITACTIVITY'),
            "placement": "top"
          }
        }, [(_vm.Activity.ID != props.row.ID) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.Activity = props.row
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('DELETEACTIVITY'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteActivity(props.$index, props.row.ID)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('MESSAGES')
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('PARENTMESSAGES')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v(_vm._s(_vm.$t('CHECKALL')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedMessageChange
    },
    model: {
      value: (_vm.school.Messages),
      callback: function($$v) {
        _vm.$set(_vm.school, "Messages", $$v)
      },
      expression: "school.Messages"
    }
  }, _vm._l((_vm.parentMessages), function(message, key) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: key,
      attrs: {
        "disabled": key === 2,
        "label": key.toString()
      }
    }, [_vm._v(_vm._s(_vm.$t(message)))])], 1)
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('EXTRAFEATURES')
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SHOWNOTIFICATIONS')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.school.Notification),
      callback: function($$v) {
        _vm.$set(_vm.school, "Notification", $$v)
      },
      expression: "school.Notification"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('DISABLE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('ENABLE')))])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('INCLUDEWIOTBOX')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.school.WiotBox),
      callback: function($$v) {
        _vm.$set(_vm.school, "WiotBox", $$v)
      },
      expression: "school.WiotBox"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('DISABLE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('ENABLE')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('THRESHOLD') + ' ' + _vm.$t('MAXIMUMDURATION')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTMINUTES')
    },
    model: {
      value: (_vm.school.Threshold.Duration),
      callback: function($$v) {
        _vm.$set(_vm.school.Threshold, "Duration", $$v)
      },
      expression: "school.Threshold.Duration"
    }
  }, _vm._l((_vm.minutes), function(num, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": num + ' ' + _vm.$t('MIN'),
        "value": num
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('THRESHOLD') + ' ' + _vm.$t('STANDINGINFRONTCHILDHOUSE')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTMINUTES')
    },
    model: {
      value: (_vm.school.Threshold.Standing),
      callback: function($$v) {
        _vm.$set(_vm.school.Threshold, "Standing", $$v)
      },
      expression: "school.Threshold.Standing"
    }
  }, _vm._l((_vm.standingMinutes), function(num, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": num + ' ' + _vm.$t('MIN'),
        "value": num
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('THRESHOLD') + ' ' + _vm.$t('DROPPEDOFINWRONGPLACE')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTMETERS')
    },
    model: {
      value: (_vm.school.Threshold.Dropped),
      callback: function($$v) {
        _vm.$set(_vm.school.Threshold, "Dropped", $$v)
      },
      expression: "school.Threshold.Dropped"
    }
  }, _vm._l((_vm.meters), function(num, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": num + ' ' + _vm.$t('METER'),
        "value": num
      }
    })
  }))], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, key) {
    return _c('span', {
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError, key))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1985749a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/school/ConfigurationManage.vue
// module id = 590
// module chunks = 1